import { Type } from 'class-transformer';

export class IXdockDailyOperationsQueryDto {
  xdock_id?: number;
  workday?: number;
}

export class IXdockDailyOperationsCategory {
  id: number | null;
  name: string;
  color: string | null;
  adet: number;
  desi: number;
}

export class IXdockDailyOperationsMetric {
  adet: number;
  desi: number;
  palet: number;

  @Type(() => IXdockDailyOperationsCategory)
  categories: IXdockDailyOperationsCategory[];
}

export class IXdockDailyOperationsVehicleSession {
  sessionId: number;
  sessionLabel: string;
  completionText: string;
  completionPercent: number;

  @Type(() => IXdockDailyOperationsMetric)
  yuklenen: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  dagitilan: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  kalan: IXdockDailyOperationsMetric;
}

export class IXdockDailyOperationsRouteCard {
  routeId: number;
  routeName: string;
  microVehicleCount: number;
  progressPercent: number;
  progressText: string;

  @Type(() => IXdockDailyOperationsMetric)
  toplam: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  dagitimda: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  teslimEdilen: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  kalan: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsVehicleSession)
  vehicleSessions: IXdockDailyOperationsVehicleSession[];
}

export class IXdockDailyOperationsSummary {
  @Type(() => IXdockDailyOperationsMetric)
  araTransfer: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  bolgeToplama: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  devirEden: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  toplam: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  dagitimda: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  teslimEdilen: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  kalan: IXdockDailyOperationsMetric;
}

export class IXdockDailyOperationsResponse {
  xdockId: number;
  xdockName: string;
  workday: number;
  workdayDate: string;
  openedMicroVehicleCount: number;

  @Type(() => IXdockDailyOperationsSummary)
  summary: IXdockDailyOperationsSummary;

  @Type(() => IXdockDailyOperationsRouteCard)
  adnCards: IXdockDailyOperationsRouteCard[];
}

// Snapshot (geçmiş kaydı) — MongoDB'den dönen ham yapı
export class IXdockDailyOperationsSnapshot {
  _id: string;
  xdockId: number;
  xdockName: string;
  workday: number;
  workdayDate: string;
  openedMicroVehicleCount: number;
  summary: IXdockDailyOperationsSummary;
  adnCards: IXdockDailyOperationsRouteCard[];
  createdAt: string;
  updatedAt: string;
}

export class IXdockDailyOperationsHistoryQueryDto {
  xdock_id: number;
  limit?: number;
  skip?: number;
}

export class IXdockDailyOperationsHistoryResponse {
  @Type(() => IXdockDailyOperationsSnapshot)
  snapshots: IXdockDailyOperationsSnapshot[];

  total: number;
  limit: number;
  skip: number;
}

// ---- ANLIK DURUM (live) ----

export type XdockLiveSection = 'bolgede' | 'gelen' | 'toplanan';

export class IXdockLiveBreakdownRow {
  sessionId: number;
  routeName: string;
  vehicleCode: string | null;
  adet: number;
  desi: number;
}

export class IXdockLiveStatusResponse {
  xdockId: number;
  xdockName: string;
  workday: number;
  generatedAt: string;

  @Type(() => IXdockDailyOperationsMetric)
  bolgede: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  gelen: IXdockDailyOperationsMetric;

  @Type(() => IXdockDailyOperationsMetric)
  toplanan: IXdockDailyOperationsMetric;

  @Type(() => IXdockLiveBreakdownRow)
  gelenAraclar: IXdockLiveBreakdownRow[];

  @Type(() => IXdockLiveBreakdownRow)
  toplananKirilim: IXdockLiveBreakdownRow[];
}

export class IXdockLivePackageRow {
  id: number;
  barcode: string;
  company: string;
  desi: number;
  status: number;
  routeName: string | null;
  vehicleCode: string | null;
  lastProcessingDate: string | null;
}

export class IXdockLivePackagesResponse {
  @Type(() => IXdockLivePackageRow)
  results: IXdockLivePackageRow[];

  page: number;
  limit: number;
  total: number;
}

/** Paket statüsü → kullanıcı etiketi (PackageStatus enum karşılıkları) */
export const XDOCK_PACKAGE_STATUS_LABELS: Record<number, string> = {
  0: 'Barkod Oluşturuldu',
  1: "City'de",
  2: 'Taşımada',
  3: 'Teslim Edildi',
  4: 'Alıcı Bulunamadı',
  5: 'İade — Hasarlı',
  6: 'İade — Yanlış Ürün',
  7: 'İade — Kabul Edilmedi',
  8: 'İade — Bilgi Eksik',
  9: 'İade — Servis Alanı',
  10: 'Otomatik Teslim'
};
